/* Quick-add from the shop and search grids.

   Delegated from document rather than bound per button: the grid grows as more
   pages load in (see wr-loadmore.js), and per-element binding would leave every
   appended card dead. The button sits inside the product link, so the click has
   to be stopped from navigating before it can add. */
(function () {
  'use strict';

  var CART_DRAWER_SECTION_ID = 'wr-cart-drawer-section';
  var busy = false;

  function updateCartBadge(count) {
    var link = document.querySelector('[data-wr-cart-link]');
    if (!link) return;
    var badge = link.querySelector('[data-wr-cart-count]');
    if (count > 0 && !badge) {
      badge = document.createElement('span');
      badge.className = 'wr-cart-badge';
      badge.setAttribute('data-wr-cart-count', '');
      link.appendChild(badge);
    }
    if (badge) badge.textContent = count > 9 ? '9+' : String(count);
  }

  function swapCartDrawerSection(sections) {
    var html = sections && sections[CART_DRAWER_SECTION_ID];
    var host = document.getElementById('shopify-section-' + CART_DRAWER_SECTION_ID);
    if (!html || !host) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.getElementById('shopify-section-' + CART_DRAWER_SECTION_ID);
    host.innerHTML = fresh ? fresh.innerHTML : parsed.body.innerHTML;
  }

  function openCartDrawer() {
    var dialog = document.getElementById('cart-drawer');
    if (dialog && !dialog.open) dialog.showModal();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wr-quick-add]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    if (busy) return;
    busy = true;

    var original = btn.textContent.trim();
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.wrQuickAdd), quantity: 1 }], sections: CART_DRAWER_SECTION_ID })
    })
      .then(function (r) {
        // A 429 carrying HTML is a Cloudflare bot challenge, not Shopify
        // throttling. See wr-pdp.js for the full reasoning — a background
        // fetch can't solve a challenge, but a page navigation can.
        if (r.status === 429) {
          var type = r.headers.get('content-type') || '';
          if (type.indexOf('text/html') !== -1) throw new Error('challenge');
          throw new Error('rate-limited');
        }
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (addResponse) {
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          updateCartBadge(cart.item_count);
          if (window.wrAnnounce) {
            window.wrAnnounce('Added to cart. ' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's') + ' in your cart.');
          }
          btn.textContent = 'Added ✓';
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1800);
          swapCartDrawerSection(addResponse.sections);
          var added = (addResponse.items && addResponse.items[0]) || addResponse;
          if (!window.wrShowCartConfirm || !window.wrShowCartConfirm(added, cart.item_count)) {
            openCartDrawer();
          }
        });
      })
      .catch(function (err) {
        if (err && err.message === 'challenge') {
          btn.textContent = 'Verifying...';
          window.location.reload();
          return;
        }
        btn.textContent = err && err.message === 'rate-limited' ? 'Too fast — try again' : original;
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1800);
      })
      .finally(function () { busy = false; });
  });
})();
